import { UseFormReturn } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { SectionDivider } from "./section-divider";
import { CompanyInformation } from "./company-information";
import { CompanyBankDetails } from "./company-bank-details";
import { ConfiguracoesPJFormData } from "@/pages/configuracoes/schemas";
import { SettingsFooterActions } from "./settings-footer-actions";

interface PessoaJuridicaTabProps {
  form: UseFormReturn<ConfiguracoesPJFormData>;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

export function PessoaJuridicaTab({ form, onSave, onCancel, isSaving }: PessoaJuridicaTabProps) {
  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Company Information Card */}
      <div className="bg-[#15203c] rounded-lg p-4 flex flex-col gap-5">
        {/* Section Title */}
        <div className="flex flex-col gap-0.5">
          <h2 className="font-['Plus_Jakarta_Sans'] font-bold text-xl text-white leading-normal">
            Pessoa Jurídica
          </h2>
          <p className="font-['Plus_Jakarta_Sans'] font-normal text-xs text-[#d1d1d1] leading-normal">
            Atualize seus dados como PJ
          </p>
        </div>

        <Form {...form}>
          <div className="flex flex-col gap-3">
            {/* INFORMAÇÕES DA EMPRESA Section */}
            <SectionDivider title="informações da empresa" />
            <CompanyInformation form={form} />
          </div>
        </Form>
      </div>

      {/* Banking Information Card */}
      <div className="bg-[#15203c] rounded-lg px-8 py-5 flex flex-col gap-5">
        <Form {...form}>
          <div className="flex flex-col gap-3">
            {/* DADOS BANCÁRIOS Section */}
            <SectionDivider title="dados bancários - pessoa jurídica" />
            <CompanyBankDetails form={form} />
          </div>
        </Form>
      </div>

      <SettingsFooterActions onSave={onSave} onCancel={onCancel} isSaving={isSaving} />
    </div>
  );
}
